import React from 'react';
import { FireIcon } from '@heroicons/react/24/solid';

const SCOPE_LABEL = { global: 'Global', especifica: 'Específica' };
const SCOPE_BADGE = {
  global: 'bg-indigo-50 text-indigo-700 ring-indigo-600/10',
  especifica: 'bg-slate-100 text-slate-600 ring-slate-500/10',
};

// Pills de "nova" / "tendência" / "global · específica" derivados por data + repetição
// do tema (calculado no backend, ver _news_trend_stats em main.py).
function NewsBadges({ article, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {article.is_new && (
        <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/10">
          Nova
        </span>
      )}
      {article.is_trending && (
        <span className="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-0.5 text-[11px] font-medium text-orange-700 ring-1 ring-inset ring-orange-600/10">
          <FireIcon className="h-3 w-3" /> Tendência
        </span>
      )}
      {article.scope && (
        <span className={`rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset ${SCOPE_BADGE[article.scope]}`}>
          {SCOPE_LABEL[article.scope]}
        </span>
      )}
    </div>
  );
}

export default NewsBadges;
